import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ApiConfig } from "config/ApiConfig";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "components/Loader/Loader";
import Features from "./Features";
import { ZendeskContext } from "context/ZendeskContext";

const Landing = () => {
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, account } = useContext(ZendeskContext);

  useEffect(() => {
    console.log("Landing component mounted");
    console.log("User:", user);
    console.log("Account:", account);
    
    const handleAuth = async () => {
      setIsLoadingLogin(true);

      try {
        const authData = {
          email: "jais@gigmos.com",
          subdomain: "d3v-pythotron",
          crm_name: "zendesk",
          id: "18477716765212",
          role: "admin",
          source: "admin_screen",
          ticketId: localStorage.getItem("zendesk_ticketId") || null,
        };

        const config = {
          headers: { "Access-Control-Allow-Origin": "*" },
          withCredentials: true,
        };

        const response = await axios.post(ApiConfig.login, authData, config);

        if (
          response.data.redirectUrl &&
          response.data.orgStatus === "outh_required"
        ) {
          const oauthWindow = window.open(
            response.data.redirectUrl,
            "OAuthLoginWindow",
            "width=500,height=500,resizable=yes,scrollbars=yes,status=yes"
          );

          if (!oauthWindow) {
            toast.error(
              "Popup was blocked. Please allow popups for this website."
            );
            return;
          }

          const checkWindowClosed = setInterval(() => {
            if (oauthWindow.closed) {
              clearInterval(checkWindowClosed);
              handleAuth();
            }
          }, 1000);
        } else {
          navigate("/landingpage");
        }
      } catch (error) {
        console.error("Login API error:", error);
        // Log or handle the error response here
        if (error.response) {
          console.log("Error response data:", error.response.data);
          console.log("Error status:", error.response.status);
          console.log("Error headers:", error.response.headers);
        } else if (error.request) {
          console.log("Error request:", error.request);
        } else {
          console.log("Error message:", error.message);
        }
        
        // Navigate or handle error as needed
        navigate("/");
      } finally {
        setIsLoadingLogin(false);
      }
    };

    // Always call handleAuth regardless of user/account data
    handleAuth();
  }, [navigate, user, account, location.state]);

  return isLoadingLogin ? <Loader /> : <Features />;
};

export default Landing;
